import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/normalize.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
